import Title from "../ui/Title";
import DeliveryItem from "./DeliveryItem";
import { selectCartItems } from "../../store/reducers/cartReducer";
import { useAppSelector } from "../../hooks";
import OrderSummary from "./OrderSummary";

const Summary = () => {
  const cartItems = useAppSelector(selectCartItems);

  return (
    <div className="lg:h-[calc(100vh-300px)] lg:overflow-scroll-y">
      <Title label="your_order" />
      {cartItems.map((cartItem) => (
        <DeliveryItem
          key={cartItem.id}
          cartItem={cartItem}
        />
      ))}
      <OrderSummary showWarning />
    </div>
  );
};

export default Summary;
